<template>
  <v-card>
    <v-card-title>
      {{ title }}
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>

    <v-data-table
      items-per-page="-1"
      :headers="headers"
      :items="data"
      item-value="name"
      class="elevation-1"
      height="75vh"
      fixed-header
      :search="search"
    >
      <template v-slot:item.name="{ value }">
        {{ beautifyString(value) }}
      </template>
    </v-data-table>
  </v-card>
</template>

<script setup>
// import { VDataTable } from 'vuetify/labs/VDataTable'
import { ref } from "vue";
import stringMethods from "../Mixins/StringManipulation";

const itemsPerPage = ref(30);
const props = defineProps({
  title: {
    type: String,
    require: true,
  },
  headers: {
    type: Array,
    required: true,
  },
  data: {
    type: Array,
    required: true,
  },
});

const search = ref("");

function beautifyString(string) {
  return stringMethods.methods.clearAndCapitalize(string);
}
</script>

<style scoped>
.table-container {
  display: flex;
  margin-top: 20px;
  flex-grow: 1;
  overflow: hidden;
}

.flex-table {
  display: flex;
  flex-grow: 1;
  width: 100%;
}

.flex-table > div {
  width: 100%;
}
</style>
